const groups = {
  general: "General",
  flame: "Flame Quality",
  planAPI11: "API Plan 11",
  planAPI23: "API Plan 23",
  planAPI32: "API Plan 32",
  planAPI52: "API Plan 52",
  planAPI53b: "API Plan 53b",
  planAPI54: "API 54 Plan ",
  "Cooling Lubricant": "Cooling Lubricant",
  steps: "Selection Variables"
};
export default groups;
